<template>
    <div class="sdr-box">
        <h5 class="box-title">{{ aboutsundair[getCurrentLocale] }}</h5>
        <p v-html="aboutsundairtext[getCurrentLocale]"></p>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    /* >>> *************************************************************** / /* Data */
    data: function() {
        return {
            aboutsundair: {
                en: 'About SUNDAIR',
                de: 'Über SUNDAIR',
            },
            aboutsundairtext: {
                en: 'is an airline founded in 2016 with headquarter in Stralsund and an operational office not far from the main city airport Berlin-Brandenburg.<br />SUNDAIR operates holiday flights to the most beautiful destinations in the Mediterranean, the Red Sea and the Canary Islands. The departures are from Berlin- Brandenburg, Kassel and Dresden Bremen and Lübeck. In addition to the holiday flights, the airline operates special and charter services and scheduled flights to the Lebanese capital, Beirut. The fleet of SUNDAIR consists of nine aircraft. These are five A320 and four A319 aircraft.',
                de: 'ist eine 2016 gegründete Fluggesellschaft mit Hauptsitz in Stralsund und operativem Standort unweit des Hauptstadtflughafens Berlin-Brandenburg.<br />SUNDAIR bedient im Ferienflugverkehr die schönsten Ziele im Mittelmeerraum, am Roten Meer und auf den Kanarischen Inseln. Die Abflüge finden von den Stationen Berlin- Brandenburg, Kassel und Dresden, Bremen und Lübeck statt. Zusätzlich zu den Ferienflügen operiert die Airline im Sonder- und Charterverkehr und bedient Linienflüge in die libanesische Hauptstadt, Beirut. Für die SUNDAIR sind insgesamt neun Flugzeuge im Einsatz. Dabei handelt es sich um fünf Maschinen vom Typ A320 und vier vom Typ A319.',
            },
            // currentLocale: 'de',
        };
    }, // eof data()
    /* <<< ****************************************************************/


    /* >>> *************************************************************** / /* Computed */
    computed: {

        ...mapGetters(['getCurrentLocale']),

    }, // eof computed{}
    /* <<< ****************************************************************/
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/shared/sidebar/AboutSundairBox.vue